import { BookOpen, FileText, HelpCircle, MessageCircle } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from 'v5/design-system/DropdownMenu';
import { SidebarFooter } from './Sidebar';
import { DevOriginSidebarBadge } from 'v5/features/core/dev-origin/DevOriginSidebarBadge';
import { OnlineStatusWidget } from 'v5/features/core/online-status/OnlineStatusWidget';
import { ThemeSwitcher } from 'v5/features/core/ThemeSwitcher';
import { WithServices } from 'v5/platform/ts/services';
import { WithDevOriginService } from 'v5/services/front/DevOriginService/DevOriginService';
import { WithFeatureService } from 'v5/services/front/FeatureService/FeatureService';
import { WithOnlineStatusService } from 'v5/services/front/OnlineStatusService/OnlineStatusService';
import { WithSupportService } from 'v5/services/front/SupportService/SupportService';
import {
  WithContentThemeService,
  WithThemeService
} from 'v5/services/front/ThemeService/ThemeService';
import { ContentThemeMenuSection } from 'v5/features/core/content-theme/contentTheme';
import { WithAppScopeService } from 'v5/services/internal/AppScopeService/AppScopeService';

export interface SidebarHelpFooterProps
  extends WithServices<
    [
      WithThemeService,
      WithContentThemeService,
      WithSupportService,
      WithOnlineStatusService,
      WithDevOriginService,
      WithFeatureService,
      WithAppScopeService
    ]
  > {}

export function SidebarHelpFooter({ services }: SidebarHelpFooterProps) {
  return (
    <>
      <DevOriginSidebarBadge services={services} className="mx-2 mb-2" />
      <SidebarFooter className="px-2">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="flex items-center gap-3 px-3 py-2 rounded text-[13px] cursor-pointer transition-colors w-full border border-transparent text-fg-default hocus:border-border-muted hocus:bg-bg-subtle/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
              <HelpCircle className="size-4 flex-shrink-0" />
              <span className="flex-1 text-left truncate">Help & Support</span>
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start" side="top" className="w-56">
            <DropdownMenuItem
              onClick={() => {
                services.supportService.show().catch(() => null);
              }}
            >
              <MessageCircle className="size-4" />
              Talk to our team
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => {
                window.open('https://support.atellio.com', '_blank');
              }}
            >
              <FileText className="size-4" />
              Send feedback
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => {
                window.open('https://support.atellio.com/en/help', '_blank');
              }}
            >
              <BookOpen className="size-4" />
              Help Center
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
        <div className="flex items-center gap-1">
          <OnlineStatusWidget services={services} />
          <ThemeSwitcher services={services} variant="icon">
            <ContentThemeMenuSection services={services} />
          </ThemeSwitcher>
        </div>
      </SidebarFooter>
    </>
  );
}
